import { useCallback, useState } from "react"

const useToggle = (initial) => {

    const [show, setShow] = useState(false || initial)

    const toggle = useCallback(() => [
        setShow(!show)
    ], [show])

    return [show, setShow, toggle]

}

export default useToggle